import { MailOutlined } from '@ant-design/icons';
import { Button, Form, Input } from 'antd';
import { useState } from 'react';
import AuthLayout from '../../../components/layout/AuthLayout';
import { getRoutes } from '../../../routes/Routes';

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => { };

  return (
    <AuthLayout
      title="Forgot Password"
      subtitle="Enter your email to get the reset link."
      actionText="Remember your password?"
      actionLabel="Log In"
      actionLink={getRoutes().login.route()}
    >
      <Form layout="vertical" size="large" onFinish={onFinish}>
        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: 'Please enter your email' },
            { type: 'email', message: 'Please enter a valid email address' },
          ]}
        >
          <Input prefix={<MailOutlined />} placeholder="john.doe@example.com" />
        </Form.Item>

        <Button
          type="primary"
          htmlType="submit"
          block
          loading={loading}
          size="large"
          className="mt-2"
        >
          Send Reset Link
        </Button>
      </Form>
    </AuthLayout>
  );
};

export default ForgotPassword;
